module.exports = __webpack_public_path__ + "static/media/mobile-image-background-checker-pattern-red-1.62f76517.svg";